import axios from "@/api/axiosInstance";
import { GetStagesRequest, GetStagesResponse } from "./types";

export const getStages = async (
  params?: GetStagesRequest,
): Promise<GetStagesResponse> => {
  const response = await axios.get<GetStagesResponse>(
    "/api/private/admin/stages",
    { params },
  );
  return response.data;
};
